/**
 * useAuthContext Hook
 *
 * Custom hook to access the authentication context.
 * Ensures the context is being used within an AuthProvider.
 */

import { useContext } from 'react';
import { AuthContext } from './AuthContext';

export function useAuthContext() {
  const context = useContext(AuthContext);

  if (context === undefined) {
    throw new Error('useAuthContext must be used within an AuthProvider');
  }

  return context;
}
